import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/common/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SiteLanguageProvider"] */ "/vercel/path0/src/components/common/SiteLanguageProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/ui/AppIcon.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/marketing-theme.css");
